import React from 'react';
import PolicyLayout from './PolicyLayout';

const PrivacyPolicy = () => (
  <PolicyLayout title="Privacy Policy" updated="14 September 2026">
    <h2>1. Introduction and Scope</h2>
    <p>
      This Privacy Policy ("Policy") governs the collection, use, and
      disclosure of personal data by Project Green ("the Company", "we",
      "us", or "our") in connection with the Project Green Intranet
      portal accessible at intranet.projectgreen.mt ("the Portal"). This
      Policy applies exclusively to personal data processed within the
      Portal and does not extend to the Company's public-facing website
      or any other Company system, each of which is governed by its own
      applicable notice.
    </p>
    <p>
      This Policy is addressed to employees, officers, contractors, and
      other authorised personnel of the Company who are granted access
      to the Portal ("Authorised Users", "you", or "your").
    </p>

    <h2>2. Data Controller</h2>
    <p>
      The data controller in respect of personal data processed through
      the Portal is Project Green, of Avenue 77, Triq in-Negozju, Zone 3,
      Central Business District, Birkirkara CBD3010, Malta ("the
      Controller"). The Chief Executive Officer of the Company acts as
      the Controller for the purposes of the Data Protection Act
      (Cap. 586) and Regulation (EU) 2016/679 (the "GDPR").
    </p>

    <h2>3. Categories of Personal Data Processed</h2>
    <p>In connection with your use of the Portal, the Company processes the following categories of personal data:</p>
    <ul>
      <li>Identification and account data obtained through Azure Active Directory authentication, including your name, email address, employee identifier, department, and role;</li>
      <li>Data voluntarily submitted by you through forms hosted on or accessible from the Portal, including the IT Support, Suggestions, and Report an Issue forms;</li>
      <li>Human resources data displayed within Portal features such as the Staff Directory and Employee Benefits modules, sourced from the Company's human resources information systems;</li>
      <li>Technical and usage data, including access logs, retained for the purposes of system administration, security monitoring, and fault resolution.</li>
    </ul>

    <h2>4. Purposes and Legal Bases of Processing</h2>
    <p>
      The Company processes the categories of personal data described
      above for the following purposes and on the following legal bases,
      in accordance with Article 6 GDPR:
    </p>
    <ul>
      <li><strong>Performance of a contract</strong> (Article 6(1)(b)): to administer your employment relationship and provide access to Portal functions relevant to your role;</li>
      <li><strong>Legitimate interests</strong> (Article 6(1)(f)): to operate, secure, and maintain the Portal, and to respond to support requests and feedback submitted through it;</li>
      <li><strong>Legal obligation</strong> (Article 6(1)(c)): where processing is required to comply with applicable employment, tax, or public administration legislation.</li>
    </ul>

    <h2>5. Recipients and Disclosure of Personal Data</h2>
    <p>
      Personal data processed through the Portal is accessible only to
      Authorised Users with a legitimate operational need to access it.
      The Company engages the following categories of processors to
      support the operation of the Portal, each of which is bound by a
      written data processing agreement consistent with Article 28
      GDPR:
    </p>
    <ul>
      <li>Microsoft Corporation, for identity and access management (Azure Active Directory);</li>
      <li>Monday.com Ltd, for form submission and internal workflow management;</li>
      <li>Talexio, for human resources record management.</li>
    </ul>
    <p>
      The Company does not disclose personal data processed through the
      Portal to any third party for marketing purposes. Disclosure to a
      law enforcement or regulatory authority will be made only where
      required or permitted by applicable law.
    </p>

    <h2>6. Data Security</h2>
    <p>
      The Company has implemented appropriate technical and
      organisational measures to protect personal data against
      unauthorised or unlawful processing, and against accidental loss,
      destruction, or damage, in accordance with Article 32 GDPR. These
      measures include authentication controls, encryption of data in
      transit and at rest, role-based access restrictions, and periodic
      review of security practices.
    </p>

    <h2>7. Data Retention</h2>
    <p>
      Personal data processed through the Portal is retained only for so
      long as is necessary to fulfil the purposes set out in this
      Policy, or as required by applicable law. Upon expiry of the
      applicable retention period, personal data is securely deleted or
      anonymised.
    </p>

    <h2>8. Rights of Data Subjects</h2>
    <p>
      Subject to the conditions and exemptions set out in the GDPR, you
      have the right to:
    </p>
    <ul>
      <li>request access to the personal data the Company holds about you;</li>
      <li>request rectification of inaccurate or incomplete personal data;</li>
      <li>request erasure or restriction of processing in certain circumstances;</li>
      <li>request portability of personal data you have provided to the Company;</li>
      <li>object to processing carried out on the basis of the Company's legitimate interests;</li>
      <li>not be subject to a decision based solely on automated processing, including profiling, which produces legal or similarly significant effects.</li>
    </ul>
    <p>
      Requests to exercise these rights should be submitted in writing
      to the Data Protection Officer using the contact details set out
      in Section 10. The Company will respond without undue delay and,
      in any event, within one month of receipt of a valid request.
    </p>

    <h2>9. Right to Lodge a Complaint</h2>
    <p>
      If you consider that the Company's processing of your personal
      data infringes applicable data protection law, you have the right
      to lodge a complaint with the Information and Data Protection
      Commissioner, Level 2, Airways House, High Street, Sliema SLM 1549,
      Malta (idpc.info@idpc.org.mt).
    </p>

    <h2>10. Contact Details</h2>
    <div className="policy-contact-box">
      <p><strong>Data Protection Officer</strong></p>
      <p>Project Green, Avenue 77, Triq in-Negozju, Zone 3, Central Business District, Birkirkara CBD3010, Malta</p>
      <p>Email: dpo.pg@projectgreen.mt</p>
      <p>Telephone: (+356) 2095 1106</p>
    </div>

    <h2>11. Amendments to this Policy</h2>
    <p>
      The Company reserves the right to amend this Policy from time to
      time. Any amendment will be published on this page together with
      an updated revision date. You are advised to review this Policy
      periodically.
    </p>
  </PolicyLayout>
);

export default PrivacyPolicy;